import React from "react";

const SaveComp = props => {
  return (
    <i
      style={{
        display: "block",
        width: "fit-content",
        fontSize: "1.2rem",
        cursor: "pointer",
        color: "green",
        marginLeft: props.noMarginLeft ? 0 : 50
      }}
      className="fas fa-save"
      onClick={props.onClick}
    />
  );
};

export default SaveComp;
